import { _pHttp } from "../_pHttp";

const getUsers = async ({
  page,
  search,
}: {
  page: string | number;
  search: string;
}) => {
  const { data } = await _pHttp.get(`/user?page=${page}&search=${search}`);
  return data;
};

const getSingleUser = async (id: string) => {
  const { data } = await _pHttp.get(`/user/${id}`);
  return data;
};

const getUserBookings = async ({
  id,
  page,
  search,
}: {
  id: string;
  page: string | number;
  search: string;
}) => {
  const { data } = await _pHttp.get(
    `/user/bookings/${id}?page=${page}&search=${search}`
  );
  return data;
};
const getPassengers = async ({
  id,
  page,
  search,
}: {
  id: string;
  page: string | number;
  search: string;
}) => {
  const { data } = await _pHttp.get(
    `/user/passengers/${id}?page=${page}&search=${search}`
  );
  return data;
};

const getSingleUserTicket = async (id: string, { page, search, filter }) => {
  const { data } = await _pHttp.get(
    `/user/tickets/${id}??page=${page}&search=${search}&filter=${filter}`
  );
  return data;
};

const getUserReported = async ({ matchId, startDate, endDate }: { matchId: string; startDate?: string; endDate?: string }) => {
  const { data } = await _pHttp.get(`ticket-matches/report/${matchId}?startDate=${startDate || ''}&endDate=${endDate || ''}`);
  return data;
};

const getUserStadiumEntryReport = async ({ matchId }: any) => {
  const { data } = await _pHttp.get(`ticket-matches/report/${matchId}`);
  return data;
};

const getExcelReport = async ({ matchId }: any) => {
  try {
    const response = await _pHttp.get(
      `ticket-matches/report/excel/${matchId}`,
      {
        responseType: "arraybuffer",
      }
    );
    const contentType =
      response.headers["content-type"] ||
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const blob = new Blob([response.data], { type: contentType });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = `matches-${matchId}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading file:", error);
    // Handle error (e.g., show error message to user)
  }
};

export {
  getUsers,
  getUserReported,
  getExcelReport,
  getSingleUser,
  getSingleUserTicket,
  getUserBookings,
  getPassengers,
};
